import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router'
import { useAuth } from '@/lib/auth/store'

/**
 * 온보딩 게이트 — 시작 전에 끝내야 하는 것만 막는다.
 *
 * 순서: 비밀번호 변경 → 개인정보 동의 → 기기 등록
 *
 * ⚠️ 여기에 단계를 늘리지 말 것. 직원이 출근을 찍기까지 거쳐야 하는 화면이
 *    많아질수록 첫날 태깅 실패가 늘어난다. DCMC 의 "시간외근무 안내 동의"는
 *    §4 에서 C(미탑재)로 분류했고 안내 배너로 흡수한다.
 */
export function OnboardingGate({ children }: { children: ReactNode }) {
  const user = useAuth((s) => s.user)
  const { pathname } = useLocation()

  if (!user) return <>{children}</>
  // 온보딩 화면 자신은 통과시킨다 (무한 리다이렉트 방지)
  if (pathname.startsWith('/onboarding') || pathname === '/change-password') return <>{children}</>

  if (user.mustChangePassword) return <Navigate to="/change-password" replace />
  if (!user.privacyConsentedAt) return <Navigate to="/onboarding/privacy" replace />

  // 기기 등록은 여기서 막지 않는다.
  // hasDevice 는 로그인 시점 스냅샷이라, 방금 등록한 사람을 다시 돌려보낼 수 있다.
  // 실제 차단은 서버가 태깅 시 403 으로 하고, 홈이 그걸 받아 등록 화면으로 안내한다.
  return <>{children}</>
}
